export const ERROR_TYPES = {
  SYNC_API: 'Sync API Errors',
  SYNC_GOV: 'Sync GovLimits',
  ASYNC_GOV: 'Async GovLimits',
  CONCURRENT_API: 'Concurrent API Errors',
  CONCURRENT_UI: 'Concurrent UI Errors',
  CONCURRENT_SERVER: 'Concurrent Server-Side Errors'
} as const;

export const ERROR_AREAS = {
  LEAD: 'Lead',
  LISTVIEWS: 'ListViews',
  OPPORTUNITY: 'Opportunity',
  ACCOUNT: 'Account',
  CONTACT: 'Contact',
  QUOTE: 'Quote',
  DISPATCH: 'Dispatch',
  CASE: 'Case',
  WORK_ORDER: 'Work Order',
  BATCH_JOB: 'BatchJob',
  FUTURES: 'Futures',
  QUEUEABLES: 'Queueables',
  CUSTOM_OBJECT: 'Custom Object',
  OTHER: 'Other'
} as const;

export type ErrorType = typeof ERROR_TYPES[keyof typeof ERROR_TYPES];
export type ErrorArea = typeof ERROR_AREAS[keyof typeof ERROR_AREAS];

export const ERROR_TYPE_DISTRACTION_MINUTES = {
  'Blended - All Errors': 25,
  'Sync API Errors': 30,
  'Sync GovLimits': 35,
  'Async GovLimits': 20,
  'Concurrent API Errors': 25,
  'Concurrent UI Errors': 15,
  'Concurrent Server-Side Errors': 40
} as const;

export interface ErrorCohort {
  id: string;
  type: ErrorType;
  area: ErrorArea;
  color: string;
  label: string;
}

export interface ErrorCohortData extends ErrorCohort {
  value: number;
  date: string;
}

export interface ErrorCalculationResult {
  errorType: keyof typeof ERROR_TYPE_DISTRACTION_MINUTES;
  errorArea: keyof typeof ERROR_AREAS;
  wage: number;
  dailyHours: number;
  isFullTime: boolean;
  isHoursMode: boolean;
  weeklyErrors: number;
  annualErrors: number;
  distractionTimePerError: number;
  annualWorkHours: number;
  totalDistractionTime: number;
  netProductiveTime: number;
  productivityLoss: number;
  maxAchievableProductivity: number;
  expectedAnnualHours: number;
  maxAchievableHours: number;
  errorImpactHours: number;
  trueLaborCost: number;
  productiveHours: number;
  employees: number;
  standardHoursPerDay: number;
  errorsPerUser: number;
  errorsPerDay: number;
  dailyDistractionHours: number;
  calculationDate: string;
  workingDays: number;
}